export default __webpack_public_path__ + "static/media/kakaopay_aliplus.622af6e7.svg";